import { motion } from "framer-motion";

export const Sobre = () => {
  const listItemVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
  };

  const listVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  return (
    <motion.section
      id="sobre"
      className="px-6 py-12"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.h1
        className="text-3xl md:text-5xl font-bold text-gray-800 mb-10"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.8 } },
        }}
      >
        Sobre nós
      </motion.h1>

      <motion.p
        className="text-gray-700 mb-6 max-w-3xl"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.8, delay: 0.2 } },
        }}
      >
        Na Anilhas Aliança, nos dedicamos à fabricação de anilhas de marcação de aves com altíssima precisão e qualidade. Nossos produtos são desenvolvidos com tecnologia de gravação a laser, garantindo legibilidade duradoura e personalização sob medida para cada criador.
      </motion.p>

      <motion.h3
        className="text-2xl md:text-3xl font-bold text-gray-800 mb-6"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.8, delay: 0.4 } },
        }}
      >
        Nosso compromisso é oferecer anilhas que unam:
      </motion.h3>

      <motion.ul
        className="pl-6 space-y-4"
        variants={listVariants}
      >
        {[
          "Anilhas de marcação personalizadas para todas as espécies;",
          "Variedade de cores e acabamentos;",
          "Para criadores comerciais, amadores e tutores.",
          "Anilhas em AÇO INOX e ALUMÍNIO;",
          "Anilhas resistentes e duráveis;",
        ].map((item, index) => (
          <motion.li
            key={index}
            className="flex items-start gap-4"
            variants={listItemVariants}
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-700 font-bold">
              {index + 1}
            </div>
            <p className="text-gray-800">{item}</p>
          </motion.li>
        ))}
      </motion.ul>

      <motion.p
        className="italic text-gray-600 mt-6"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { duration: 0.8, delay: 2 } },
        }}
      >
        Somos a escolha certa para criadores que buscam confiança, excelência e resultados.
      </motion.p>
    </motion.section>
  );
};
